import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * D203 受訂託工單模組權限 hook
 *
 * 基於 pgCode = "pwd203f1"（SYS_Program 中的受訂託工單程式代碼）
 */
export function useD203Permissions() {
  return useModulePermission(Modules.PWD203);
}
